<template>
<span>

    <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
        <v-container fluid grid-list-md>
            <v-row>

                <v-col cols="10" xs="12" sm="12" md="8" lg="10" xl="10">
                    <v-row>

                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-select v-model="productcategory.product_dept_id" :items="loadProductDepts" item-text="prod_dp_nome" item-value="prod_dp_id" label="Selecione um Departamento..." :rules="rules.contentSectionRules" required outlined></v-select>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field v-model="productcategory.prod_c_codigo" label="Código" outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field v-model="productcategory.prod_c_nome" :rules="rules.nomeRules" label="Nome" outlined required></v-text-field>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field v-model="productcategory.prod_c_ordem" label="Ordem" outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <v-text-field v-model="productcategory.prod_c_link" label="Link" outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="d-flex flex-row">
                            <v-switch class="mr-5" color="lime" v-model="productcategory.prod_c_status" label="Status"></v-switch>
                            <v-switch color="lime" v-model="productcategory.prod_c_show_menu" label="Mostrar no menu"></v-switch>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="text-right">
                            <v-btn class="btn-salvar" :disabled="!valid" color="success" @click="onSubmit">
                                <v-icon class="mdi mdi-check"></v-icon>{{btnLabel}}
                            </v-btn>
                        </v-col>

                    </v-row>
                </v-col>

                <v-col cols="2" xs="12" sm="12" md="4" lg="2" xl="2">

                    <v-layout row wrap justify-center column pt-3>

                        <v-flex d-flex v-if="previewIcone || productcategory.prod_c_icone">
                            <v-card>
                                <v-img v-if="previewIcone" :src="previewIcone" aspect-ratio="3"></v-img>
                                <v-img v-if="productcategory.prod_c_icone  && !previewIcone" :src="`${base_url}upload/product_category/i/${productcategory.prod_c_icone}`" aspect-ratio="3"></v-img>

                                <v-card-actions class="justify-center">
                                    <v-btn flat icon>
                                        <v-icon @click="$refs.fileIcone.click()">cloud_upload</v-icon>
                                    </v-btn>
                                    <v-btn flat icon>
                                        <v-icon @click.prevent="removePreviewIcone">highlight_off</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex d-flex justify-center>
                            <input type="file" ref="fileIcone" style="display:none;" id="fileIcone" @change="onFileIconeChange" />
                            <v-btn v-if="!previewIcone && !productcategory.prod_c_icone" color="blue-grey" class="btn-upload white--text" @click="$refs.fileIcone.click()">
                                Adicionar Icone
                                <v-icon right dark>cloud_upload</v-icon>
                            </v-btn>
                        </v-flex>

                        <v-flex d-flex v-if="previewBanner || productcategory.prod_c_banner">
                            <v-card>
                                <v-img v-if="previewBanner" :src="previewBanner" aspect-ratio="3"></v-img>
                                <v-img v-if="productcategory.prod_c_banner && !previewBanner" :src="`${base_url}upload/product_category/b/${productcategory.prod_c_banner}`" aspect-ratio="3"></v-img>

                                <v-card-actions class="justify-center">
                                    <v-btn flat icon>
                                        <v-icon @click="$refs.fileBanner.click()">cloud_upload</v-icon>
                                    </v-btn>
                                    <v-btn flat icon>
                                        <v-icon @click.prevent="removePreviewBanner">highlight_off</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex d-flex justify-center>
                            <input type="file" ref="fileBanner" style="display:none;" id="fileBanner" @change="onFileBannerChange" />
                            <v-btn v-if="!previewBanner && !productcategory.prod_c_banner" color="blue-grey" class="btn-upload white--text" @click="$refs.fileBanner.click()">
                                Adicionar Banner
                                <v-icon right dark>cloud_upload</v-icon>
                            </v-btn>
                        </v-flex>

                    </v-layout>

                </v-col>
            </v-row>
        </v-container>
    </v-form>

</span>
</template>

<script>
import {
    URL_BASE
} from '../../../../config/configs'

export default {
    name: "FormProductCategoryComponent",
    created() {
        this.$store.dispatch('loadProductDepts');
    },
    computed: {
        loadProductDepts() {
            return this.$store.state.productdepts.items.data;
        }
    },
    props: {
        productcategory: {
            require: false,
            type: Object | Array,
            default: () => {
                return {
                    prod_c_id: '',
                    prod_c_product_dept_id: '',
                    prod_c_codigo: '',
                    prod_c_nome: '',
                    prod_c_slug: '',
                    prod_c_icone: '',
                    prod_c_banner: '',
                    prod_c_link: '',
                    prod_c_ordem: '',
                    prod_c_status: true,
                    prod_c_show_menu: true,
                }
            }
        },
        update: {
            require: false,
            type: Boolean,
            default: false
        },
        btnLabel: {
            require: false,
            type: String,
            default: 'Salvar'
        },
        require: true,
    },
    data() {
        return {
            valid: true,
            rules: {
                nomeRules: [
                    v => !!v || 'Campo Nome é obrigatório',
                    v => (v && v.length <= 100) || 'Nome precisa ter até 100 Caracteres'
                ],
            },
            uploadIcone: null,
            fileNameIcone: 'Selecione uma foto',
            fileNameBanner: 'Selecione uma foto',
            previewIcone: null,
            previewBanner: null,
            base_url: URL_BASE
        }
    },
    methods: {
        onSubmit() {

            if (this.$refs.form.validate()) {
                const action = this.update ? 'updateProductCategory' : 'storeProductCategory';
                const msg = this.update ? 'Dados atualizados com sucesso' : 'Cadastro efetuado com sucesso';

                const formData = new FormData();

                if (this.uploadIcone !== null)
                    formData.append('prod_c_icone', this.uploadIcone);

                if (this.uploadBanner !== null)
                    formData.append('prod_c_banner', this.uploadBanner);

                formData.append('prod_c_id', this.productcategory.prod_c_id);
                formData.append('product_dept_id', this.productcategory.product_dept_id);
                formData.append('prod_c_codigo', this.productcategory.prod_c_codigo);
                formData.append('prod_c_nome', this.productcategory.prod_c_nome);
                formData.append('prod_c_slug', this.productcategory.prod_c_slug);
                formData.append('prod_c_icone', this.productcategory.prod_c_icone);
                formData.append('prod_c_banner', this.productcategory.prod_c_banner);
                formData.append('prod_c_link', this.productcategory.prod_c_link);
                formData.append('prod_c_ordem', this.productcategory.prod_c_ordem);
                formData.append('prod_c_status', this.productcategory.prod_c_status);
                formData.append('prod_c_show_menu', this.productcategory.prod_c_show_menu);

                this.$store.dispatch(action, formData)
                    .then(() => {
                        this.$swal({
                            position: "center",
                            icon: "success",
                            title: msg,
                            showConfirmButton: true,
                            timer: 6000
                        });
                        this.$router.push({
                            name: 'product-categories'
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: 'Erro',
                            text: 'Algo deu errado',
                            showConfirmButton: true,
                            timer: 6000
                        });
                        this.errors = error.response.data.errors
                    })
            } else {
                this.$swal({
                    position: "center",
                    icon: "warning",
                    title: 'Alguns campos requer sua atenção',
                    text: 'Verifique os campos em vermelho',
                    showConfirmButton: true,
                    timer: 6000
                });
            }

        },
        onFileIconeChange(e) {
            let files = e.target.files || e.dataTransfer.files;

            if (!files.length)
                return;

            this.uploadIcone = files[0];
            this.fileNameIcone = this.uploadIcone.name;

            this.previewIconeImage(files[0]);
        },
        onFileBannerChange(e) {
            let files = e.target.files || e.dataTransfer.files;

            if (!files.length)
                return;

            this.uploadBanner = files[0];
            this.fileNameBanner = this.uploadBanner.name;

            this.previewBannerImage(files[0]);
        },
        previewIconeImage(file) {

            let reader = new FileReader();
            reader.onload = (e) => {
                this.previewIcone = e.target.result;
            };
            reader.readAsDataURL(file)
        },
        previewBannerImage(file) {

            let reader = new FileReader();
            reader.onload = (e) => {
                this.previewBanner = e.target.result;
            };
            reader.readAsDataURL(file)
        },
        removePreviewIcone() {
            this.previewIcone = null;
            this.uploadIcone = null;
            this.productcategory.prod_c_icone = ''
        },
        removePreviewBanner() {
            this.previewBanner = null;
            this.uploadBanner = null;
            this.productcategory.prod_c_banner = ''
        },
    },
    components: {

    }
};
</script>

<style scoped>
.theme--dark.v-sheet {
    background-color: #303030;
    border-color: #303030;
    color: #fff;
    box-shadow: none;
}

.btn-upload,
.btn-salvar {
    margin: 0;
}

/*Also*/
.fileinput-button input {
    position: absolute;
    top: 0;
    right: 0;
    margin: 0;
    opacity: 0;
    -ms-filter: 'alpha(opacity=0)';
    filter: 'alpha(opacity=0)';
    font-size: 200px;
    direction: ltr;
    cursor: pointer;
}

.img-preview {
    max-width: 100%;
    height: 120px;
}
</style>
